<div class="bk-panel set-table">
  <data-table label="Test numbers" [seamless]="true" [maxHeight]="'640px'" [skeletonColumns]="4" [loading]="loading">
    @if (rows.length > 0 || loading) {
      <table class="bk-log">
        <thead>
          <tr>
            <th scope="col" class="col-main">Name</th>
            <th scope="col" class="col-phone">Phone number</th>
            <th scope="col" class="col-added">Added</th>
            <th scope="col" class="col-actions"><span class="bk-sr-only">Actions</span></th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track row.key) {
            <tr>
              <td class="col-main">
                <span class="bk-msg">
                  <span class="bk-msg__subject">{{ row.name }}</span>
                  @if (row.email) {
                    <span class="bk-msg__preview">{{ row.email }}</span>
                  }
                </span>
              </td>
              <td class="col-phone">
                @if (row.phone) {
                  <span class="tct__phone">{{ row.phone }}</span>
                } @else {
                  <span class="tct__none">No number</span>
                }
              </td>
              <td class="quiet col-added">{{ row.added }}</td>
              <td class="col-actions">
                <span class="bk-row-actions">
                  <!-- Send test: a real SMS, confirmed in the next step -->
                  <ng-container
                    *hasPermission="{ category: 'MESSAGE_CONTENT_MANAGEMENT', permission: 'send-test-msg' }"
                  >
                    <button
                      type="button"
                      class="bk-icon-btn"
                      [attr.aria-disabled]="row.phone ? null : 'true'"
                      [attr.aria-label]="'Send a test SMS to ' + row.name"
                      [attr.aria-describedby]="row.phone ? null : 'tct-why-' + row.key"
                      [matTooltip]="row.phone ? 'Send test SMS' : 'Add a phone number first'"
                      (click)="openSendModal(row.contact)"
                    >
                      <span class="bk-sym" aria-hidden="true">send</span>
                    </button>
                    @if (!row.phone) {
                      <span class="bk-sr-only" [id]="'tct-why-' + row.key">Add a phone number first</span>
                    }
                  </ng-container>

                  @if (canManage) {
                    <button
                      type="button"
                      class="bk-icon-btn"
                      [attr.aria-label]="'Edit ' + row.name"
                      matTooltip="Edit"
                      (click)="openShowEditModal(row.contact)"
                    >
                      <span class="bk-sym" aria-hidden="true">edit</span>
                    </button>
                    <button
                      type="button"
                      class="bk-icon-btn tct__danger"
                      [attr.aria-label]="'Remove ' + row.name"
                      matTooltip="Remove"
                      (click)="handleOpenDeletePrompt(row.contact)"
                    >
                      <span class="bk-sym" aria-hidden="true">delete</span>
                    </button>
                  }
                </span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <div class="set-empty">
        <app-empty-state
          [icon]="loadFailed ? 'error' : searchTerm.trim() ? 'search' : 'smartphone'"
          [message]="emptyMessage"
          [hint]="emptyHint"
          [actionLabel]="loadFailed ? 'Try again' : !searchTerm.trim() && canManage ? 'Add test number' : ''"
          [actionIcon]="loadFailed ? 'refresh' : 'add'"
          size="medium"
          (action)="loadFailed ? retry.emit() : addTestContact.emit()"
        />
      </div>
    }
  </data-table>
</div>

@if (totalItems > pageSize || page > 0) {
  <div class="set-pagination">
    <app-pagination
      [totalPages]="totalTestContactsPages"
      [currentPage]="testContactsPage"
      [totalItems]="totalItems"
      [pageSize]="pageSize"
      [loading]="testContactsLoading"
      (changePage)="updateTestContactsPage($event)"
      (pageSizeChange)="onPageSizeChange($event)"
    ></app-pagination>
  </div>
}

<!-- MODALS -->
<!-- edit -->
<update-test-user-form
  [selectedTestUser]="selectedTestContact"
  [openModal]="showEditModal"
  (onClose)="closeEditModal()"
  (fetchTestContacts)="fetchTestContacts.emit()"
  (onSuccess)="onUpdateSuccess()"
/>

<!-- send test -->
<app-send-test-sms-form [openModal]="showSendModal" [contact]="selectedTestContact" (onClose)="closeSendModal()" />

<!-- delete -->
<app-prompt-card
  buttonText="Remove test number"
  [title]="'Remove ' + selectedName + '?'"
  tone="danger"
  [openModal]="showDeletePrompt"
  (onClose)="closeDeletePrompt()"
  (onButtonClick)="deleteContact()"
  [loading]="isDeleting"
>
  <p class="tct__prompt">
    @if (selectedPhone) {
      <strong>{{ selectedPhone }}</strong> will no longer be offered for test sends.
    } @else {
      This test number will no longer be offered for test sends.
    }
    Messages already sent to it are not affected.
  </p>
</app-prompt-card>
